import { createPhantomTypeSchema, MaybeT, t, } from '../../../../universal';
import { _, React } from '../../../lib';
import { FileUpload, FileUploadItemT, FileUploadTemp, } from '../file-upload';
export const FormTypeFileSingle = (settings) => ({
    ...settings,
    valueDefaults: {
        def: () => null,
        validators: [],
    },
    emptyLabel: settings.fullWidth ?? false,
    removeLabel: settings.fullWidth ?? false,
    height: _.max([36, (settings.height ?? 0) + 8]) ?? 36,
    typeMap: {
        schemaRaw: createPhantomTypeSchema(MaybeT(FileUploadItemT)),
        schemaPublic: createPhantomTypeSchema(MaybeT(FileUploadItemT)),
        toPublic: x => x,
        toInternal: x => x,
    },
    llmInfo: null,
    jsx: props => (React.createElement(UploadFileFormFieldSingle, { value: props.value, onUpdate: props.onUpdate, className: props.className ?? '', height: settings.height, accept: settings.accept })),
});
export const FormTypeFileMultiple = (settings) => ({
    ...settings,
    valueDefaults: {
        def: () => [],
        validators: [],
    },
    emptyLabel: settings.fullWidth ?? false,
    removeLabel: settings.fullWidth ?? false,
    height: _.max([36, (settings.height ?? 0) + 8]) ?? 36,
    typeMap: {
        schemaRaw: createPhantomTypeSchema(t.Array(FileUploadItemT)),
        schemaPublic: createPhantomTypeSchema(t.Array(FileUploadItemT)),
        toPublic: x => x,
        toInternal: x => x,
    },
    llmInfo: null,
    jsx: props => (React.createElement(UploadFileFormFieldMultiple, { value: props.value, onUpdate: props.onUpdate, className: props.className ?? '', height: settings.height, accept: settings.accept })),
});
const UploadFileFormFieldSingle = (props) => {
    const [value, setValue] = React.useState(props.value ? [props.value] : []);
    return (React.createElement(FileUpload, { multiple: false, value: value, onUpdate: v => {
            const f = v[0];
            setValue(f ? [f] : []);
            props.onUpdate(f);
        }, className: props.className, height: props.height, placeholder: props.dragText, accept: props.accept }));
};
const UploadFileFormFieldMultiple = (props) => {
    const init = React.useRef(false);
    const [value, setValue] = React.useState(props.value);
    React.useEffect(() => {
        if (init.current) {
            console.log('Updating', value);
            props.onUpdate(_.compact(value));
        }
    }, [value]);
    React.useEffect(() => {
        init.current = true;
    }, []);
    return (React.createElement(FileUpload, { multiple: true, value: value, onUpdate: v => {
            setValue(v);
            props.onUpdate(_.compact(v));
        }, className: props.className, height: props.height, placeholder: props.dragText, accept: props.accept }));
};
const UpoloadFileFormFieldTemp = (props) => {
    const [value, setValue] = React.useState(props.value ? [props.value] : []);
    return (React.createElement(FileUploadTemp, { value: value, onUpdate: v => {
            const f = v[0];
            setValue(f ? [f] : []);
            props.onUpdate(f);
        }, className: props.className, height: props.height, placeholder: props.dragText, accept: props.accept }));
};
export const FormTypeFileTempSingle = (settings) => ({
    ...settings,
    valueDefaults: {
        def: () => null,
        validators: [],
    },
    emptyLabel: settings.fullWidth ?? false,
    removeLabel: settings.fullWidth ?? false,
    height: _.max([36, (settings.height ?? 0) + 8]) ?? 36,
    typeMap: {
        schemaRaw: createPhantomTypeSchema(MaybeT(FileUploadItemT)),
        schemaPublic: createPhantomTypeSchema(MaybeT(FileUploadItemT)),
        toPublic: x => x,
        toInternal: x => x,
    },
    llmInfo: null,
    jsx: props => (React.createElement(UpoloadFileFormFieldTemp, { value: props.value, onUpdate: v => {
            props.onUpdate(v);
        }, className: props.className ?? '', height: settings.height })),
});
//# sourceMappingURL=fields-file.js.map